import { Routes } from '@angular/router';
import { authGuard } from '../app/core/guards/auth.guard';
import { RouteAccessGuard } from './core/guards/route-access.guard';
import { appInitGuard } from './core/guards/app-init.guard';
import { customerDropMultipleGuard } from './core/guards/customer-drop-multiple.guard';

export const routes: Routes = [
  {
    path: '',
    canActivate: [appInitGuard],
    children: [
  {
    path: 'home',
    loadComponent: () =>
      import('./features/home/pages/home/home.component').then(
        (m) => m.HomeComponent
      ),
  },
  {
    path: 'config',
    loadComponent: () =>
      import('./features/device-config/device-config.component').then(
        (m) => m.DeviceConfigComponent
      ),
      canActivate: [RouteAccessGuard]
  },
  {
    path: 'cache-checker',
    loadComponent: () =>
      import('./features/cache-status-checker/cache-status-checker.component').then(
        (m) => m.CacheStatusCheckerComponent
      ),
    canActivate: [authGuard, RouteAccessGuard],
  },
  {
    path: 'menu',
    loadComponent: () =>
      import('./features/menu/pages/menu/menu.component').then(
        (m) => m.MenuComponent
      ),
    canActivate: [authGuard],
  },
  {
    path: 'customer',

    children: [
      {
        path: 'drop',
        loadComponent: () =>
          import(
            './features/customer-drop/pages/customer-drop/customer-drop.component'
          ).then((m) => m.CustomerDropComponent),
        canActivate: [authGuard, RouteAccessGuard],
      },
      {
        path: 'drop-multiple',
        loadComponent: () =>
          import(
            './features/customer-drop-multiple/pages/customer-drop-multiple/customer-drop-multiple.component'
          ).then((m) => m.CustomerDropMultipleComponent),
        canActivate: [authGuard, customerDropMultipleGuard],
      },
      {
        path: 'collect',
        loadComponent: () =>
          import(
            './features/customer-collect/pages/customer-collect/customer-collect.component'
          ).then((m) => m.CustomerCollectComponent),
        canActivate: [authGuard, RouteAccessGuard],
      },
    ],
  },
  {
    path: 'parcel',

    children: [
      {
        path: 'putaway',
        loadComponent: () =>
          import('./features/put-away/pages/put-away/put-away.component').then(
            (m) => m.PutAwayComponent
          ),
        canActivate: [authGuard, RouteAccessGuard],
      },
    ],
  },
  {
    path: 'courier',

    children: [
      {
        path: 'pickup',
        loadComponent: () =>
          import(
            './features/courier-pickup/pages/courier-pickup/courier-pickup.component'
          ).then((m) => m.CourierPickupComponent),
        canActivate: [authGuard, RouteAccessGuard],
      },
      {
        path: 'delivery',
        loadComponent: () =>
          import(
            './features/courier-delivery/pages/courier-delivery/courier-delivery.component'
          ).then((m) => m.CourierDeliveryComponent),
        canActivate: [authGuard, RouteAccessGuard],
      },
    ],
  },
  {
    path: 'management',
    ///management/parcel-lookup
    children: [
      {
        path: 'menu',
        loadComponent: () =>
          import(
            './features/menu/components/management-menu/management-menu.component'
          ).then((m) => m.ManagementMenuComponent),
        canActivate: [authGuard, RouteAccessGuard],
      },

      {
        path: 'parcel-lookup',
        loadComponent: () =>
          import(
            './features/parcel-lookup/pages/parcel-lookup/parcel-lookup.component'
          ).then((m) => m.ParcelLookupComponent),
        canActivate: [authGuard, RouteAccessGuard],
      },

      {
        path: 'node-stock',
        loadComponent: () =>
          import('./features/node-stock/pages/node-stock.component').then(
            (m) => m.NodeStockComponent
          ),
        canActivate: [authGuard, RouteAccessGuard],
      },
    ],
  },
  {
    path: 'alerts',

    children: [
      {
        path: 'menu',
        loadComponent: () =>
          import(
            './features/menu/components/alerts-menu/alerts-menu.component'
          ).then((m) => m.AlertsMenuComponent),
        canActivate: [authGuard],
      },
      {
        path: 'expired',
        children: [
          {
            path: '',
            loadComponent: () =>
              import(
                './features/expired-parcels/pages/expired-parcels/expired-parcels.component'
              ).then((m) => m.ExpiredParcelsComponent),
            canActivate: [authGuard],
          },
          {
            // Parameterized child route for a specific parcelsRefCode
            path: ':parcelsRefCode',
            loadComponent: () =>
              import(
                './features/expired-parcels/pages/expired-unpack/expired-unpack.component'
              ).then((m) => m.ExpiredUnpackComponent),
            canActivate: [authGuard, RouteAccessGuard],
          },
        ],
      },

      {
        path: 'ncr',
        loadComponent: () =>
          import(
            './features/non-collection-return/pages/non-collection-return/non-collection-return.component'
          ).then((m) => m.NonCollectionReturnComponent),
        canActivate: [authGuard, RouteAccessGuard],
      },
      {
        path: 'unreceived',
        children: [
          {
            path: '',
            loadComponent: () =>
              import(
                './features/unreceived-parcels/pages/unreceived-parcels/unreceived-parcels.component'
              ).then((m) => m.UnreceivedParcelsComponent),
            canActivate: [authGuard, RouteAccessGuard],
          },
          {
            // Parameterized child route for a specific parcelsRefCode
            path: ':parcelsRefCode',
            loadComponent: () =>
              import(
                './features/unreceived-parcels/pages/unreceived-unpack/unreceived-unpack.component'
              ).then((m) => m.UnreceivedUnpackComponent),
            canActivate: [authGuard],
          },
        ]
      },
      {
        path: 'ncr-process',
        loadComponent: () =>
          import(
            './features/non-collection-return/components/ncr-process/ncr-process.component'
          ).then((m) => m.NcrProcessComponent),
        canActivate: [authGuard],
      },

      {
        path: 'returns',
        loadComponent: () =>
          import(
            './features/general-returns/pages/general-returns.component'
          ).then((m) => m.GeneralReturnsComponent),
        canActivate: [authGuard],
      },

      {
        path: 'return-process',
        loadComponent: () =>
          import(
            './features/general-returns/components/return-process/return-process.component'
          ).then((m) => m.ReturnProcessComponent),
        canActivate: [authGuard],
      },

      {
        path: 'missing',
        loadComponent: () =>
          import(
            './features/missing-parcels-found/pages/missing-parcels-found.component'
          ).then((m) => m.MissingParcelsFoundComponent),
        canActivate: [authGuard],
      },
      {
        path: 'messages',
        loadComponent: () =>
          import('./features/alerts/pages/alerts/alerts.component').then(
            (m) => m.AlertsComponent
          ),
        canActivate: [authGuard],
      },
    ],
  },
  {
    path: 'admin',

    children: [
      {
        path: 'menu',
        loadComponent: () =>
          import(
            './features/menu/components/admin-menu/admin-menu.component'
          ).then((m) => m.AdminMenuComponent),
        canActivate: [authGuard],
      },
      {
        path: 'device',
        loadComponent: () =>
          import(
            './features/device-info/pages/device-info/device-info.component'
          ).then((m) => m.DeviceInfoComponent),
        canActivate: [authGuard],
      },
      {
        path: 'users',
        loadComponent: () =>
          import(
            './features/user-management/pages/user-management.component'
          ).then((m) => m.UserManagementComponent),
        canActivate: [authGuard],
      },
      {
        path: 'cache',
        loadComponent: () =>
          import(
            './features/cache-management/cache-management.component'
          ).then((m) => m.CacheManagementComponent),
        canActivate: [authGuard, RouteAccessGuard],
      },
    ],
  },

  {
    path: 'update-my-password',
    loadComponent: () =>
      import('./features/user-management/pages/update-my-password/update-my-password.component').then(
        (m) => m.UpdateMyPasswordComponent
      ),
    canActivate: [authGuard],
  },

  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full',
  },
  {
    path: '**',
    redirectTo: 'home',
  },
  ],
  },
];
